import { render, staticRenderFns } from "./contentIncome.vue?vue&type=template&id=33be5acf&scoped=true&"
import script from "./contentIncome.vue?vue&type=script&lang=js&"
export * from "./contentIncome.vue?vue&type=script&lang=js&"
import style0 from "./contentIncome.vue?vue&type=style&index=0&id=33be5acf&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be5acf",
  null
  
)

export default component.exports